import React from 'react';

// MUI
import ButtonGroup, { ButtonGroupProps } from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";

// Styles
import styles from './style.module.scss';

// Types
type SegmentedProps = {
  options: { value: any; label: string }[];
  value: any;
  onChange: (value: any) => void;
  className?: string;
} & ButtonGroupProps

const MuiSegmented: React.FC<SegmentedProps> = ({ options = [], value, onChange, className, ...props }) => {
  return (
    <ButtonGroup className={`${styles.root} ${className}`} {...props}>
      {options.map((option) => (
        <Button
          key={option.value}
          variant={value === option.value ? 'contained' : 'outlined'}
          classes={{
            root: styles.button,
            contained: styles.button_contained,
          }}
          color="primary"
          onClick={() => onChange && onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </ButtonGroup>
  )
}

export default MuiSegmented;
